export const da = {
  category: "Hvilke produkter er du interesseret i?",
  category_id: "6b00a7abee",
  boot: "Fodboldstøvler",
  boot_id: "213e750cda",
  shirt: "Fodboldtrøjer",
  shirt_id: "3dbaaad8ba",
  goalkeeper: "Målmandsprodukter",
  goalkeeper_id: "a9ea007912",
  kids: "Fodboldprodukter til børn",
  kids_id: "7eb4e85bd8",
};

export const sv = {
  category: "Vilka produkter är du intresserad av?",
  category_id: "9846122641",
  boot: "Fotbollsskor",
  boot_id: "404f2e0054",
  shirt: "Fotbollströjor",
  shirt_id: "20aca22894",
  goalkeeper: "Målvaktsprodukter",
  goalkeeper_id: "48393fbe5f",
  kids: "Fotbollsprodukter för barn",
  kids_id: "0db5d23028",
};

export const nb = {
  category: "Hvilke produkter er du interessert i?",
  category_id: "c69f8a888f",
  boot: "Fotballsko",
  boot_id: "b0fd5bd6a7",
  shirt: "Fotballdrakter",
  shirt_id: "905c107010",
  goalkeeper: "Keeperprodukter",
  goalkeeper_id: "348df1762f",
  kids: "Fotballprodukter til barn",
  kids_id: "983702293c",
};

export const en = {
  category: "What products are you interested in?",
  category_id: "26c2ec431b",
  boot: "Football boots",
  boot_id: "f19f1c76b0",
  shirt: "Football shirts",
  shirt_id: "2b768ac8d3",
  goalkeeper: "Goalkeeper products",
  goalkeeper_id: "6fde755e2d",
  kids: "Kids football products",
  kids_id: "260af78fe4",
};

export const fi = {
  category: "Mistä tuotteista olet kiinnostunut?",
  category_id: "624b3324cb",
  boot: "Jalkapallokengaet",
  boot_id: "c4338deb2e",
  shirt: "Pelipaidat",
  shirt_id: "241bbe5e24",
  goalkeeper: "Maalivahdin tarvikkeet",
  goalkeeper_id: "47f35e9951",
  kids: "Lasten jalkapallotuotteet",
  kids_id: "444ee0b6f7",
};

export const nl = {
  category: "Welke producten interesseren jou het meest?",
  category_id: "9868254aa1",
  boot: "Voetbalschoenen",
  boot_id: "ab48576c6d",
  shirt: "Voetbalshirts",
  shirt_id: "451de36af9",
  goalkeeper: "Keepersuitrusting",
  goalkeeper_id: "85a28d411e",
  kids: "Producten voor kinderen",
  kids_id: "55d9c0af6c",
};

export const de = {
  category: "Für welche Produkte interessierst du dich?",
  category_id: "0e70128757",
  boot: "Fussballschuhe",
  boot_id: "b69849fd42",
  shirt: "Fussballtrikots",
  shirt_id: "3e2339abbc",
  goalkeeper: "Torwartausruestung",
  goalkeeper_id: "db6ab8ba3d",
  kids: "Kinder Fussballprodukte",
  kids_id: "e899ccc2c7",
};

export const fr = {
  category: "Quels articles vous intéressent?",
  category_id: "388e8e7dbe",
  boot: "Chaussures de foot",
  boot_id: "f163ef8c80",
  shirt: "Maillots de foot",
  shirt_id: "e3f5137643",
  goalkeeper: "Equipement de gardien",
  goalkeeper_id: "8dadc8d3d5",
  kids: "Articles pour enfant",
  kids_id: "01fcbb92fc",
};

export const at = {
  category: "Für welche Produkte interessierst du dich?",
  category_id: "d47fa8d25a",
  boot: "Fussballschuhe",
  boot_id: "91de5ef377",
  shirt: "Fussballtrikots",
  shirt_id: "c03f434854",
  goalkeeper: "Torwartausruestung",
  goalkeeper_id: "cfe880a7f0",
  kids: "Kinder Fussballprodukte",
  kids_id: "a1b1faaa66",
};
